import PropTypes from "prop-types";
import { UpdateBankAccountConfirmationModalContainer } from "./UpdateBankAccountConfirmationModal.styles";
import { HelpCenterIcon } from "assets/icons";

const UpdateBankAccountConfirmationModal = ({ show, onHide, onConfirm }) => {
  return (
    <UpdateBankAccountConfirmationModalContainer show={show} onHide={onHide}>
      <div className="modal-header">
        <h2 className="modal-title">Update your bank account</h2>
      </div>

      <div className="modal-body-content">
        {/* Info Banner */}
        <div className="info-banner">
          <div className="info-icon">
            <HelpCenterIcon />
          </div>
          <p className="info-text">
            Are you sure you want to update your bank account? Once you make
            this change, it cannot be undone.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button className="cancel-button" onClick={onHide}>
            Go back
          </button>
          <button className="confirm-button" onClick={onConfirm}>
            Next
          </button>
        </div>
      </div>
    </UpdateBankAccountConfirmationModalContainer>
  );
};

UpdateBankAccountConfirmationModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export { UpdateBankAccountConfirmationModal };
